module.exports = __webpack_public_path__ + "static/media/ubahn.3777f722.png";